__webpack_require__.p = "/p/wujing/front/wujing-web-console/";